<template>
  <LayoutDashboard>
    <h5 class="font-weight-bold m-0">
      My DHM
    </h5>
    <small class="text-info font-weight-bold">
      My DHM
    </small>
    <div class="box-white mt-3 px-4 py-3">
      <div class="mb-3">
        <h5>
          <small class="font-weight-bold">
            Filter
          </small>
        </h5>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-4 col-lg-4 mb-3"
          :class="{ 'border border-danger py-2': !isValidDate }"
        >
          <h6
            for="start-date"
            class="m-0"
          >
            <small class="font-weight-bold">
              {{ $t("filter-assessment.period-date") }}
            </small>
          </h6>
          <DateFilter
            :start-date="filters.startDate"
            :end-date="filters.endDate"
            @returnDate="getDate"
          />
          <div v-if="!isValidDate">
            <small class="text-danger font-weight-bold">
              {{ $t("filter-assessment.wrong-date") }}
            </small>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-info btn-sm font-weight-bold mr-2"
          type="button"
          @click="applyFilter"
        >
          {{ $t("filter-assessment.apply") }}
        </button>
        <div
          class="btn btn-outline-info btn-sm font-weight-bold"
          type="button"
          @click="resetFilter"
        >
          {{ $t("filter-assessment.clear") }}
        </div>
      </div>
    </div>

    <div class="box-white mt-3 px-4 py-2">
      <Table
        v-if="!loadingTable"
        :permission="permission"
        :fetch-list-assessment="fetchListAssessment"
        :export-list-assessment="exportListAssessment"
        :handling-search="handlingSearch"
        :list-assessment="dataList"
        :pagination="pagination"
        :list-header="listHeader"
        :is-my-dhm="true"
        :from-email="fromEmail"
        :id-from-email="idFromEmail"
        :is-loading-export="isLoadingExport"
      />
      <div
        v-if="loadingTable"
        class="text-center"
      >
        <div
          class="spinner-border spinner-border-sm"
          role="status"
        >
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </div>
    </div>
  </LayoutDashboard>
</template>

<script>
import FileSaver from 'file-saver'
import { format } from 'date-fns'
import { SURVEY_ID } from '@/fixtures'
import Api from '@/utils/Api'
import LayoutDashboard from '@/components/LayoutDashboard'
import Table from '@/components/ListAssessment/Table'
import DateFilter from '@/components/ListAssessment/Filter/Date'

const LSKEY_FILTERS = 'filters-my-assessment'

export default {
  name: 'Myassessment',

  components: {
    LayoutDashboard,
    Table,
    DateFilter
  },

  props: {
    fromEmail: {
      type: Boolean,
      default: () => (false)
    },
    idFromEmail: {
      type: String,
      default: () => ('')
    }
  },

  data () {
    return {
      user: JSON.parse(localStorage.getItem('profile')) || {},
      dataList: {
        data: []
      },
      listHeader: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        nextPage: 0,
        prevPage: 0,
        pageCount: 0,
        totalPage: 0,
        totalData: 0,
        visibleAssessment: 0
      },
      filters: {
        startDate: '',
        endDate: ''
      },
      loadingTable: false,
      isLoadingExport: false,
      search: '',
      listQuestionAssessment: [],
      permission: []
    }
  },

  computed: {
    isValidDate: function () {
      return this.filters.startDate <= this.filters.endDate
    },
    isEmployee () {
      return this.user.role?.name === 'Employee'
    }
  },

  async created () {
    this.getPermission()
    if (localStorage.getItem(LSKEY_FILTERS)) {
      this.filters = JSON.parse(localStorage.getItem(LSKEY_FILTERS))
    } else {
      this.initialDates()
    }
    await this.getTable()
    await this.getQuestionAssessment()
    this.initialHeaderTable()
  },

  methods: {
    getPermission () {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      const index = dataLoc.role.permissions.findIndex(element => element.category === 'my_dhm')
      this.permission = dataLoc.role.permissions[index]
    },
    async getTable () {
      this.loadingTable = true
      await this.fetchListAssessment(
        this.pagination.currentPage,
        this.pagination.perPage
      )
      this.loadingTable = false
    },
    initialDates () {
      this.filters.startDate = new Date()
      this.filters.endDate = format(new Date(), 'yyyy-MM-dd')
      this.filters.startDate.setMonth(this.filters.startDate.getMonth() - 1)
      this.filters.startDate = format(this.filters.startDate, 'yyyy-MM-dd')
    },
    async getQuestionAssessment () {
      const { data } = await Api.surveys.get(SURVEY_ID)
      this.listQuestionAssessment = data.questions
    },
    initialHeaderTable () {
      this.listHeader = [
        'table-assessment.head-table.action',
        'table-assessment.head-table.date',
        'table-assessment.head-table.risk',
        'table-assessment.head-table.work-location',
        'table-assessment.head-table.comorbid'
      ]
      for (let i = 0; i < this.listQuestionAssessment.length; i++) {
        this.listHeader.push(['table-assessment.head-table.question', i + 1])
      }
    },
    applyFilter () {
      localStorage.setItem(LSKEY_FILTERS, JSON.stringify(this.filters))
      this.getTable()
    },
    resetFilter () {
      this.initialDates()
      this.filters = {
        startDate: this.filters.startDate,
        endDate: this.filters.endDate
      }
      localStorage.setItem(LSKEY_FILTERS, JSON.stringify(this.filters))
      this.fetchListAssessment(1, 10)
    },
    getDate (newDate, type) {
      this.filters[type] = newDate
    },
    async fetchListAssessment (pages, limits) {
      const { data } = await Api.surveys.listResponses(SURVEY_ID, {
        Filters: [
          `createdAt>=${this.filters.startDate}`,
          `createdAt<=${this.filters.endDate} 23:59:59`,
          `UserId==${this.user.id}`,
          ...this.takeAdditionalFilters()
        ].join(','),
        Sorts: '-createdAt',
        Search: this.search,
        Page: pages,
        PageSize: limits
      })
      this.dataList = data
      this.pagination.nextPage = data.currentPage + 1
      this.pagination.currentPage = data.currentPage
      this.pagination.prevPage = data.currentPage - 1
      this.pagination.totalPage = data.totalPage
      this.pagination.totalData = data.totalData
      this.pagination.visibleAssessment = data.data.length
    },
    async exportListAssessment () {
      this.isLoadingExport = true
      const { data } = await Api.surveys.exportResponses(SURVEY_ID, {
        Filters: [
          `createdAt>=${this.filters.startDate}`,
          `createdAt<=${this.filters.endDate} 23:59:59`,
          ...this.takeAdditionalFilters()
        ].join(','),
        Sorts: '-createdAt'
      })
      this.isLoadingExport = false
      const prefix = this.isEmployee ? 'My_DHM' : 'All_DHM'
      const fileName = `${prefix}_${this.formatFilterDate(this.filters.startDate, 'yyyyMMMdd')}-${this.formatFilterDate(this.filters.endDate, 'yyyyMMMdd')}.xlsx`
      FileSaver.saveAs(data, fileName)
    },
    formatFilterDate (date, dateFormat) {
      return format(new Date(date), dateFormat)
    },
    takeAdditionalFilters () {
      return Object.keys(this.filters)
        .filter(key => !!this.filters[key])
        .filter(key => !['startDate', 'endDate'].includes(key))
        .map(key => `${key}==${Array.isArray(this.filters[key]) ? this.filters[key].join('|') : this.filters[key]}`)
    },
    handlingSearch (keyword) {
      this.search = keyword
      this.fetchListAssessment(1, 10)
    }
  }
}
</script>

<style scoped>
.bg {
  background-color: #f5efff;
  min-height: 750px;
}
.box-white {
  background-color: #ffffff;
  min-height: 20px;
  border-radius: 18px;
}

@media screen and (max-width: 576px) {
  .bg {
    min-height: 800px;
  }
}
</style>
